import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-buy',
    templateUrl: './buy.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BuyComponent {

}
